import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

/**
 * App key header is a header sent to fetch requests
 * that is public
 */
@Injectable()
export class ApiKeyInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const { appApiKey } = environment;
    if (appApiKey) {
      return next.handle(request.clone({
        headers: request.headers.set('appKey', appApiKey),
      }));
    }
    return next.handle(request);
  }
}
